import {Component, OnInit, ViewChild} from '@angular/core';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {EstadoWidgetComponent} from './widgets/estado.widget.component';
import {VentasWidgetComponent} from './widgets/ventas.widget.component';
import {IndicadoresWidgetComponent} from './widgets/indicadores.widget.component';
import {ParticipacionWidgetComponent} from './widgets/participacion.widget.component';
import {IndGeneralWidgetComponent} from './widgets/ind.general.widget.component';
import {CategoriasWidgetComponent} from './widgets/categorias.widget.component';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {ReporteServices} from '../services/reporte.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {TypeaheadMatch} from 'ngx-bootstrap';
import * as moment from 'moment';
import {RegionalServices} from '../../CoreModule/services/regional.services';
import {RegionalEntity} from '../../CoreModule/entities/regional.entity';
import {UsuarioEntity} from '../../CoreModule/entities/usuario.entity';
import {UsuarioServices} from '../../CoreModule/services/usuario.services';
import {SocketServices} from '../../CoreModule/services/socket.services';

@Component({
  selector: 'reporte-regionales',
  templateUrl: '../templates/reporte.regional.dashboard.component.html'
})
export class ReporteRegionalDashboardComponent implements OnInit {
  public tiendas: TiendaEntity[] = [];
  public regionales: RegionalEntity[] = [];
  public userReg: UsuarioEntity[] = [];
  public regionalSelect: RegionalEntity;
  public userSelect: UsuarioEntity;
  public tiendaSelect: TiendaEntity;
  public tSelectName: string = '';

  public fecha1: string;
  public fecha2: string;

  public tituloReport: string = '';


  @ViewChild(EstadoWidgetComponent, { static: true })
  private rEstado: EstadoWidgetComponent;

  @ViewChild(VentasWidgetComponent, { static: true })
  private rVentas: VentasWidgetComponent;

  @ViewChild(IndicadoresWidgetComponent, { static: true })
  private rIndicadores: IndicadoresWidgetComponent;

  @ViewChild(ParticipacionWidgetComponent, { static: true })
  private rParticipacion: ParticipacionWidgetComponent;

  @ViewChild(IndGeneralWidgetComponent, { static: false })
  private rIndGeneral: IndGeneralWidgetComponent;

  @ViewChild(CategoriasWidgetComponent, { static: true })
  private rMixVentas: CategoriasWidgetComponent;

  opcSem: any[] = [];
  public semSelect: number;
  public mesSelect: number;
  public trimSelect: number;
  public semesSelect: number;
  public anoSelect: number = 2019;

  public verSec: number = 0;

  constructor(private ts: TiendaServices, private regs: RegionalServices, private rs: ReporteServices, private spinner: NgxSpinnerService, private us: UsuarioServices) {
    for (let j = 1; j < 53; j++) {
      this.opcSem.push(j);
    }
  }

  ngOnInit(): void {
    this.spinner.show();

    this.rs.obsSendDashboard.subscribe((d:any)=>{
      // console.log(d);
      this.spinner.hide();
      this.rEstado.ingresarDatos(d.estado, d.indGeneral);
      this.rVentas.ingresarDatos(d.ventas);
      this.rIndicadores.ingresarDatos(d.indicadores);
      this.rMixVentas.ingresarDatos(d.mixVentas);
    });

    // calculo de indicadores

    // el regional solo puede ver  el total de sus tiendas
    // this.ts.getAllTiendas().subscribe(d => {
    //   this.tiendas = d.data.tiendas;
    //   this.spinner.hide();
    //   this.tiendaSelect = this.tiendas[0];
    //   this.tSelectName = this.tiendaSelect.nombre;
    // });

    this.regs.getAllRegional().subscribe(d => {
      this.regionales = d.data.regionales;

    });

    this.us.getAllUser().subscribe(d => {


      this.userReg = d.data.usuarios.filter((u) => {
        return u.rol.id == 5 || u.rol.id == 11;
      });

      this.userReg.map((u)=>{
        u.nombreCompleto = u.nombres + " " + u.apellidos;
      })
      this.spinner.hide();
    });


  }

  tiendaSeleccionada(event: TypeaheadMatch) {
    this.tiendaSelect = event.item;
  }

  regionalSeleccionada(event: TypeaheadMatch) {
    this.regionalSelect = event.item;
  }

  usuarioSeleccionado(event: TypeaheadMatch) {
    this.userSelect = event.item;
  }

  consultarDatos() {
    this.verSec = 0;
    if (this.userSelect) {
      let fechaIni = moment(this.fecha1);
      let fechaFin = moment(this.fecha2);

      this.tituloReport = `Reporte regional del ${fechaIni.format('DD-MM-YYYY')} al ${fechaFin.format('DD-MM-YYYY')}`;

      // this.rIndicadores.consultar(3, this.userSelect.id, fechaIni.format('YYYY-MM-DD'), fechaFin.format('YYYY-MM-DD'));
      // this.rParticipacion.consultar(3, this.userSelect.id, fechaIni.format('YYYY-MM-DD'), fechaFin.format('YYYY-MM-DD'));
      // this.rMixVentas.consultar(3, this.userSelect.id, fechaIni.format('YYYY-MM-DD'), fechaFin.format('YYYY-MM-DD'));
      // this.rIndGeneral.consultar(4, this.tiendaSelect.idDB, fechaIni.format('YYYY-MM-DD'), fechaFin.format('YYYY-MM-DD'));
      this.spinner.show();
      this.rs.getInfoDashboard(3, this.userSelect.id, fechaIni.format('YYYY-MM-DD'), fechaFin.format('YYYY-MM-DD'));
      this.rEstado.consultandoDatos();
      this.rVentas.consultandoDatos();
      this.rIndicadores.consultandoDatos();
      this.rMixVentas.consultando();
    }
  }

  consultarSemana() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }

    let dia1 = moment();
    // let dia2 = moment();
    this.fecha1 = dia1.day(1).format('YYYY-MM-DD');
    this.fecha2 = moment(dia1).add(7, 'd').format('YYYY-MM-DD');
    this.consultarDatos();
  }

  consultarMes() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }

    let dia1 = moment();
    let dia2 = moment();
    this.fecha1 = dia1.date(1).format('YYYY-MM-DD');
    this.fecha2 = dia2.date(31).format('YYYY-MM-DD');
    this.consultarDatos();
  }

  consultarTrimestre() {
    if (this.verSec != 2) {
      this.verSec = 2;
      return;
    }

    if (this.anoSelect == undefined) {
      alert('Ingrese un año');
      return;
    }


    let opc = +this.trimSelect;

    switch (opc) {
      case 1:
        this.fecha1 = `${this.anoSelect}-01-01`;
        this.fecha2 = `${this.anoSelect}-03-31`;

        break;
      case 2:
        this.fecha1 = `${this.anoSelect}-04-01`;
        this.fecha2 = `${this.anoSelect}-06-30`;
        break;
      case 3:
        this.fecha1 = `${this.anoSelect}-07-01`;
        this.fecha2 = `${this.anoSelect}-09-30`;
        break;
      case 4:
        this.fecha1 = `${this.anoSelect}-10-01`;
        this.fecha2 = `${this.anoSelect}-12-31`;
        break;

    }


    this.consultarDatos();
  }

  consultarSemestre() {
    if (this.verSec != 3) {
      this.verSec = 3;
      return;
    }
    if (this.anoSelect == undefined) {
      alert('Ingrese un año');
      return;
    }

    let opc = +this.semesSelect;

    switch (opc) {
      case 1:
        this.fecha1 = `${this.anoSelect}-01-01`;
        this.fecha2 = `${this.anoSelect}-06-30`;
        break;
      case 2:
        this.fecha1 = `${this.anoSelect}-07-01`;
        this.fecha2 = `${this.anoSelect}-12-31`;
        break;
    }

    this.consultarDatos();
  }

  consultarAnual() {
    if (this.verSec != 4) {
      this.verSec = 4;
      return;
    }
    if (this.anoSelect == undefined) {
      alert('Ingrese un año');
      return;
    }
    this.fecha1 = `${this.anoSelect}-01-01`;
    this.fecha2 = this.fecha2 = `${this.anoSelect}-12-31`;

    this.consultarDatos();
  }

  consultarFechas() {
    this.verSec = 1;
  }

  consultarHoy() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }

    let dia1 = moment();
    let dia2 = moment();
    this.fecha1 = dia1.format('YYYY-MM-DD');
    this.fecha2 = dia2.format('YYYY-MM-DD');
    this.consultarDatos();
  }
}
